module.exports = __webpack_public_path__ + "img/7-min.df3358e2.jpg";